<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Key Performance Indicator</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">
                    Key Performance Indicator
                  </li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Key Performance Indicator</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Title</th>
                      <th>Type</th>
                      <th class="text-right">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in KPIs" v-bind:key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.type == 0 ? "Subjective" : "Objective" }}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="setKPI(item)"
                              data-target="#edit_activity_status"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="setKPI(item)"
                              data-target="#delete_activity_status"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div
          id="add_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Key Performance Indicator</h5>
                <button
                  type="button"
                  class="close"
                  id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Title <span class="text-danger">*</span></label>
                    <input
                      v-model="title"
                      id="name"
                      name="title"
                      class="form-control"
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Select Type <span class="text-danger">*</span></label
                    >
                    <select
                      v-model="type"
                      placeholder="Select Type"
                      class="form-control"
                    >
                      <option disabled value=""></option>
                      <option value="0">Subjective</option>
                      <option value="1">Objective</option>
                    </select>
                  </div>
                  <!-- <div class="form-group" v-if="type === 'Objective'">
                        <label>Filter By Activity Type <span class="text-danger">*</span></label>
                        <select 
                          placeholder="Select Activity Type" 
                          class="form-control" 
                          v-model="activityTypeId"
                        >
                            <option disabled value="">Select Activity Type</option>
                            <option 
                              v-for="item in performanceActivityTypes"
                              :key="item.id"
                              :value="item.activityTypeId"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div> -->
                  <div class="form-group" v-if="type == 1">
                    <label
                      >Measureable Field
                      <span class="text-danger">*</span></label
                    >
                    <select
                      id="measureableFieldset"
                      name="measureableFieldset"
                      class="form-control"
                      v-model="measureableFieldset"
                    >
                      <option disabled>Select Fieldset</option>
                      <option
                        v-for="item in Fieldsets"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-if="type == 1">
                    <label
                      >Method of Measurement
                      <span class="text-danger">*</span></label
                    >
                    <select class="form-control" v-model="method">
                      <option disabled>Select Method</option>
                      <option value="SUM"
                        >Sum of Measureable field in all activites</option
                      >
                      <option value="AVERAGE"
                        >Average of Measureable field in all activites</option
                      >
                      <option value="COUNT"
                        >Count of Particular Value in Measureable field of all
                        activites</option
                      >
                    </select>
                  </div>
                  <div class="form-group" v-if="method == 'COUNT'">
                    <label
                      >Expected value of Measureable field to Count
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="expFieldSetValue"
                      id="name"
                      name="expFieldSetValue"
                      class="form-control"
                      type="text"
                    />
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Key Performance Indicator Modal -->

        <!-- Edit Key Performance Indicator Modal -->
        <div
          id="edit_activity_status"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Key Performance Indicator</h5>
                <button
                  type="button"
                  class="close"
                  id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onPutSubmit">
                  <div class="form-group">
                    <label>Title <span class="text-danger">*</span></label>
                    <input
                      v-model="kpi.title"
                      id="name"
                      name="title"
                      class="form-control"
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Select Type <span class="text-danger">*</span></label
                    >
                    <select
                      v-model="kpi.type"
                      placeholder="Select Type"
                      class="form-control"
                    >
                      <option disabled value=""></option>
                      <option :value="0">Subjective</option>
                      <option :value="1">Objective</option>
                    </select>
                  </div>
                  <div class="form-group" v-if="kpi.type == 1">
                    <label
                      >Measureable Field
                      <span class="text-danger">*</span></label
                    >
                    <select
                      id="measureableFieldset"
                      name="measureableFieldset"
                      class="form-control"
                      v-model="kpi.measureableFieldset"
                    >
                      <option disabled>Select Fieldset</option>
                      <option
                        v-for="item in Fieldsets"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-if="kpi.type == 1">
                    <label
                      >Method of Measurement
                      <span class="text-danger">*</span></label
                    >
                    <select class="form-control" v-model="kpi.method">
                      <option disabled>Select Method</option>
                      <option value="SUM"
                        >Sum of Measureable field in all activites</option
                      >
                      <option value="AVERAGE"
                        >Average of Measureable field in all activites</option
                      >
                      <option value="COUNT"
                        >Count of Particular Value in Measureable field of all
                        activites</option
                      >
                    </select>
                  </div>
                  <div class="form-group" v-if="kpi.method == 'COUNT'">
                    <label
                      >Expected value of Measureable field to Count
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="kpi.expFieldSetValue"
                      id="name"
                      name="expFieldSetValue"
                      class="form-control"
                      type="text"
                    />
                  </div>
                  <div class="submit-section">
                    <button
                      class="btn btn-primary submit-btn"
                      @click="onPutSubmit"
                      data-dismiss="modal"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_activity_status"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    id="closeEdit"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Delete Key Performance Indicator</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                        @click="onDeleteSubmit"
                      >
                        Delete
                      </a>
                    </div>
                    <div class="col-6">
                      <a
                        data-dismiss="modal"
                        id="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { performanceService } from "@/services/performanceService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },

  data() {
    return {
      title: "",
      type: "",
      measureableFieldset: "",
      expFieldSetValue: null,
      method: "",
      error: "",
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      keyPerformanceIndicators: [],
      Fieldsets: [],
      KPIs: [],
      kpi: {},
      submitted: true,
      loading: false
    };
  },

  validations: {},

  methods: {
    setKPI(item) {
      this.kpi = item;
      console.log(item);
    },
    GetKPIs() {
      performanceService.getKPIs(this.company.id).then(model => {
        this.KPIs = model;
      });
    },
    GetMeasureableFieldSets() {
      performanceService.getMeasureableFieldSets(this.company.id).then(
        model => {
          console.log(`model`, model);
          this.Fieldsets = model;
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.loading = true;

      performanceService
        .addKPI(
          this.company.id,
          this.title,
          this.measureableFieldset,
          this.expFieldSetValue,
          this.method,
          this.type
        )
        .then(
          id => {
            performanceService.getKPIs(this.company.id).then(model => {
              this.KPIs = model;
              $("#close").click();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    onPutSubmit() {
      performanceService
        .updateKPIs(
          this.kpi.id,
          this.company.id,
          this.kpi.title,
          this.kpi.measureableFieldset,
          this.kpi.expFieldSetValue,
          this.kpi.method,
          this.kpi.type,
          0
        )
        .then(
          id => {
            performanceService.getKPIs(this.company.id).then(model => {
              this.KPIs = model;
              $("#closeEdit").click();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    onDeleteSubmit() {
      this.loading = true;
      performanceService.removeKPI(this.kpi.id).then(
        id => {
          performanceService.getKPIs(this.company.id).then(model => {
            this.KPIs = model;
            $("#closeDelete").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.GetKPIs();
    this.GetMeasureableFieldSets(this.company.id);

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "keyPerformanceIndicator"
};
</script>



// WEBPACK FOOTER //
// src/components/settings/performance/keyPerformanceIndicator.vue